<template>
  <div class="container flex header">
    <div :class="{ show: showMenu }" class="flex center navigation">
      <nav class="menu-links">
        <div>
          <router-link to="/" class="menu-link" title="Home" @click="toggleMenu">Home</router-link>
        </div>
        <div>
          <router-link to="/bio" class="menu-link" title="Bio" @click="toggleMenu">Bio</router-link>
        </div>
        <div>
          <router-link to="/shows" class="menu-link" title="Upcoming Shows" @click="toggleMenu">Shows</router-link>
        </div>
        <div>
          <router-link to="/shop" class="menu-link" title="Shop, buy records and merch"
            @click="toggleMenu">Shop</router-link>
        </div>
        <div>
          <router-link to="/contact" class="menu-link" title="Contact" @click="toggleMenu">Contact</router-link>
        </div>
      </nav>
    </div>
    <svg v-if="$route.name === 'homepage'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 19.225" class="logo">
      <path
        d="M103.381.314c-7.137 2.003-9.386 11.26-3.958 16.286 3.474 3.216 8.954 3.457 12.463.55.978-.811.971-1.043-.056-1.856l-.831-.659-.723.551c-4.734 3.611-11.39.281-11.349-5.677.039-5.753 6.651-9.108 11.162-5.665l.969.739.802-.783c1.001-.978.995-1.06-.135-1.912-2.175-1.639-5.727-2.309-8.344-1.574m286.025.047l-2.223.066v18.178H400v-2.481h-10.336V10.81l1.582-.134c.87-.073 2.683-.133 4.031-.133h2.449V8.002l-4.031.109-4.031.109V2.954l1.395-.132c.768-.072 3.093-.132 5.168-.133L400 2.687V.207l-4.186.044a427.25 427.25 0 00-6.408.11M81.034 7.273v6.86l-4.773-6.705L71.488.724 70.163.662 68.837.601l.001 4.299c0 2.364.061 6.462.136 9.105l.136 4.806h2.202l.055-6.832.054-6.833 4.851 6.833 4.85 6.832h2.392V.413h-2.48v6.86m44.857 2.236v9.096h2.481V.413h-2.481v9.096m15.918 0v9.096h2.48v-7.856h3.064c5.423 0 7.874-1.614 7.888-5.196.015-3.847-2.253-5.137-9.039-5.138l-4.393-.002v9.096m26.046 0v9.096h12.817v-2.481h-10.336v-5.375h8.062v-2.48h-8.062V2.894h10.336V.413h-12.817v9.096m100.259.103v9.199H278.863l-.002-.465a9.911 9.911 0 00-.131-1.24l-.128-.775h-8.008V.413h-2.48v9.199m23.153-3.876c0 2.928.061 7.068.136 9.199l.135 3.876h2.209V.413h-2.481l.001 5.323m15.916 3.773v9.096H320v-2.274h-10.336v-5.582h8.062v-2.48h-8.062V2.894H320V.413h-12.817v9.096m26.254 0v9.096h2.475l.054-6.729.055-6.728 4.754 6.717 4.755 6.717 1.292.011 1.292.012V.413h-2.481v13.714L340.76 7.27 335.886.413h-2.449v9.096m27.08-7.855v1.24h5.788v15.711h2.481V2.894h5.788V.413H360.517v1.241M0 9.716v9.095h2.481v-7.855l3.152-.001c5.43-.002 7.813-1.572 7.799-5.139C13.417 1.937 11.103.62 4.304.62H0v9.096m26.047 0v9.095h2.48v-7.855l1.809.005c2.958.007 3.141.142 5.87 4.328l2.297 3.522h1.442c1.149 0 1.42-.058 1.332-.288-.273-.711-4.917-7.589-5.197-7.696-.213-.082.016-.284.714-.632 4.036-2.011 3.454-7.975-.905-9.269-.767-.228-2.15-.306-5.436-.306h-4.406v9.096m27.08 0v9.095h2.48V.62h-2.48v9.096m163.169-7.813c.268.715 1.772 4.813 3.342 9.105l2.856 7.803h2.577l.846-2.325c.465-1.279 1.952-5.372 3.303-9.096l2.458-6.77-1.369.003-1.368.002-2.564 7.133c-1.41 3.923-2.593 7.103-2.628 7.067-.036-.036-1.22-3.223-2.632-7.083L218.551.724l-1.37-.062-1.371-.061.486 1.302m27.149 7.649c-3.795 10.463-3.542 9.259-1.944 9.259h1.295l.718-2.067.718-2.067H251.747l.61 1.602c.335.881.675 1.811.755 2.067.145.462 2.816.758 2.8.31-.003-.085-1.474-4.155-3.269-9.044L249.38.724l-1.344-.061-1.345-.06-3.246 8.949m-91.784-5.914c2.874 2.318.668 4.631-4.418 4.631h-2.954V2.866l3.289.066 3.289.065.794.641M9.31 3.566c1.902.959 2.151 2.868.542 4.166l-.793.64-3.289.066-3.289.066V3.101h2.953c2.652 0 3.048.047 3.876.465m26.133-.056c2.164 1.047 2.065 3.553-.181 4.573-.693.315-1.37.384-3.789.388l-2.946.004V3.101h3.036c2.602 0 3.156.058 3.88.409m214.034 4.827c.7 1.913 1.272 3.565 1.272 3.669 0 .107-1.237.19-2.812.19-2.596 0-2.802-.027-2.669-.361.079-.199.709-1.924 1.399-3.833.69-1.909 1.319-3.397 1.397-3.307.078.089.714 1.728 1.413 3.642"
        fill-rule="evenodd"></path>
    </svg>
    <h1 v-else>{{ $route.name }}</h1>

    <svg v-if="!showMenu" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 290 290" class="menu-icon container"
      title="Open menu" @click="toggleMenu">
      <path
        d="M0 220h70v70H0zM0 110h70v70H0zM0 0h70v70H0zM110 220h70v70h-70zM110 110h70v70h-70zM110 0h70v70h-70zM220 220h70v70h-70zM220 110h70v70h-70zM220 0h70v70h-70z">
      </path>
    </svg><svg v-if="showMenu" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 174.239 174.239"
      class="menu-icon container" title="Close menu" @click="toggleMenu">
      <path
        d="M146.537 1.047a3.6 3.6 0 00-5.077 0L89.658 52.849a3.6 3.6 0 01-5.077 0L32.78 1.047a3.6 3.6 0 00-5.077 0L1.047 27.702a3.6 3.6 0 000 5.077l51.802 51.802a3.6 3.6 0 010 5.077L1.047 141.46a3.6 3.6 0 000 5.077l26.655 26.655a3.6 3.6 0 005.077 0l51.802-51.802a3.6 3.6 0 015.077 0l51.801 51.801a3.6 3.6 0 005.077 0l26.655-26.655a3.6 3.6 0 000-5.077L121.39 89.658a3.6 3.6 0 010-5.077l51.801-51.801a3.6 3.6 0 000-5.077L146.537 1.047z">
      </path>
    </svg>
  </div>
</template>

<script>
export default {
  name: "AppNavigation",
  data() {
    return {
      showMenu: false,
    };
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu;
      document.body.style.overflow = this.showMenu ? "hidden" : "visible";
    },
  },
};
</script>

<style scoped>
h1 {
  margin: 0;
  line-height: 1;
}

.header {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.navigation {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: var(--black);
  z-index: 8;
  top: -100%;
  opacity: 0;
}

.navigation.show {
  top: 0;
  opacity: 1;
}

.menu-link {
  display: inline-block;
  margin-bottom: var(--margin-default);
  font-size: 1.6rem;
  text-transform: uppercase;
  letter-spacing: 7px;
  border-bottom: 1px solid transparent;
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

.menu-link.router-link-exact-active,
.menu-link:hover {
  border-bottom: 1px solid #fff;
}

.logo {
  width: 500px;
  max-width: 100%;
  height: 24px;
  fill: var(--white);
}

@media screen and (max-width: 640px) {
  .logo {
    width: 250px;
    margin-right: calc(1.8rem + var(--margin-small));
  }
}

.menu-icon {
  position: absolute;
  top: 0;
  right: 0;
  width: 2rem;
  height: 2rem;
  fill: var(--highlight);
  z-index: 9;
  cursor: pointer;
  transition: var(--transition);
}

@media screen and (max-width: 640px) {
  .menu-icon {
    /* width: 1.8rem;
    height: 1.8rem; */
    padding: var(--margin-small);
  }
}

.menu-icon:hover {
  opacity: 0.8;
}
</style>